export const mspfCreateDeviceErrorWhitelist = [
  'MSPF上のデータ不整合です。imeiとmobileNoが異なるdeviceに紐づいています。',
  'MSPF上でimeiまたはmobileNoが既に使用されています。'
] as const;
